import { takeEvery, put } from "redux-saga/effects";

import { ADD_PRODUCT, ADD_PRODUCT_RED, GET_PRODUCT_RED, UPDATE_PRODUCT_RED, DELETE_PRODUCT_RED, GET_PRODUCT, UPDATE_PRODUCT, DELETE_PRODUCT, UPDATE_PRODUCT_QUANTITY_RED, UPDATE_PRODUCT_QUANTITY } from "../Constants";
import { createMultipatDataRecord, deleteRecord, getRecord, updateMultipatDataRecord, updateRecord } from './Service/APICallingService'

function* createSaga(action) {
    let response = yield createMultipatDataRecord('product', action.payload)
    yield put({ type: ADD_PRODUCT_RED, payload: response.data })
}

function* getSaga(action) {
    let response = yield getRecord('product')
    yield put({ type: GET_PRODUCT_RED, payload: response.data })
}

function* updateSaga(action) {
    let response = yield updateMultipatDataRecord('product', action.payload)
    yield put({ type: UPDATE_PRODUCT_RED, payload: response.data })
}

function* updateQuantitySaga(action) {
    let response = yield updateRecord('product/quantity', action.payload)
    yield put({ type: UPDATE_PRODUCT_QUANTITY_RED, payload: response.data })
}

function* deleteSaga(action) {
    yield deleteRecord('product', action.payload)
    yield put({ type: DELETE_PRODUCT_RED, payload: action.payload })
}

export default function* productSagas() {
    yield takeEvery(ADD_PRODUCT, createSaga)
    yield takeEvery(GET_PRODUCT, getSaga)
    yield takeEvery(UPDATE_PRODUCT, updateSaga)
    yield takeEvery(UPDATE_PRODUCT_QUANTITY, updateQuantitySaga)
    yield takeEvery(DELETE_PRODUCT, deleteSaga)
}